export default {"src":"/planos/_next/static/media/equifax-shield-3.5e998328.svg","height":24,"width":22,"blurWidth":0,"blurHeight":0};